import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import ListIcon from "@mui/icons-material/List";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";

const HoldBookingDialog = ({ open, handleClose }) => {
  return (
    <>
      <Dialog
        maxWidth="lg"
        open={open}
        PaperProps={{
          style: { borderTop: "4px #a54d4d solid" },
        }}
      >
        <Grid container display={"flex"} justifyContent="center">
          <Grid
            item
            xs={12}
            display={"flex"}
            justifyContent="center"
            alignSelf={"center"}
            pt={3}
            px={6}
          >
            <ReportProblemRoundedIcon
              sx={{ fontSize: "75px", color: "#a54d4d" }}
            />
          </Grid>
          <Grid item alignSelf={"center"} pt={2} px={6}>
            <Typography variant="h6" textAlign={"center"} mb={1}>
              {"Configuration Missing"}
            </Typography>
            <Typography gutterBottom>{}</Typography>
          </Grid>
        </Grid>
        <DialogContent dividers>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="body1" my={1}>
                {`Unable to process booking due to missing configurations in FC.
                Contact your FC and ask them to set required configurations.
                `}
              </Typography>
              <Typography>List of configurations required -</Typography>
              <List dense={true}>
                <ListItem>
                  <ListItemIcon>
                    <ListIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={"primary"}
                        type="body1"
                        style={{ fontWeight: 500 }}
                      >
                        Case Configuration
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <ListIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={"primary"}
                        type="body1"
                        style={{ fontWeight: 500 }}
                      >
                        Dock Details
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <ListIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        color={"primary"}
                        type="body2"
                        style={{ fontWeight: 500 }}
                      >
                        Working Hours
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ mx: 2 }}
            variant="outlined"
            onClick={() => handleClose()}
          >
            Ok{" "}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default HoldBookingDialog;
